import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LogIn } from "lucide-react";

export default function MyAccountFAB() {
  const nav = useNavigate();
  return (
    <motion.button
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.5, type: "spring", stiffness: 200 }}
      onClick={() => nav("/login")}
      data-testid="my-account-fab"
      aria-label="Ver mi pago"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-gradient-to-r from-yellow-400 to-orange-500 text-black font-bold uppercase tracking-widest text-xs shadow-2xl hover:shadow-yellow-500/50 hover:scale-105 transition-transform border-2 border-yellow-300"
    >
      <LogIn className="w-4 h-4" />
      <span>Ver mi pago</span>
    </motion.button>
  );
}
